import p2_1 from "./p2-1.jpg";
import p2_2 from "./p2-2.jpg";
import p2_3 from "./p2-3.jpg";
import p2_4 from "./p2-4.jpg";
import p2_5 from "./p2-5.jpg";
import p2_6 from "./p2-6.jpg";
import p2_7 from "./p2-7.jpg";
import p2_8 from "./p2-8.jpg";
import p2_9 from "./p2-9.jpg";
import p2_10 from "./p2-10.jpg";
import p2_11 from "./p2-11.jpg";
import p2_12 from "./p2-12.jpg";
import p2_13 from "./p2-13.jpg";
import p2_14 from "./p2-14.jpg";
import p2_15 from "./p2-15.jpg";
import p2_16 from "./p2-16.jpg";
import p2_17 from "./p2-17.jpg";
import p2_18 from "./p2-18.jpg";
import p2_19 from "./p2-19.jpg";
import p2_20 from "./p2-20.jpg";
import p2_21 from "./p2-21.jpg";
import p2_22 from "./p2-22.jpg";
import p2_23 from "./p2-23.jpg";
import p2_24 from "./p2-24.jpg";
import p2_25 from "./p2-25.jpg";
import p2_26 from "./p2-26.jpg";
import p2_27 from "./p2-27.jpg";
import p2_28 from "./p2-28.jpg";
import p2_29 from "./p2-29.jpg";
import p2_30 from "./p2-30.jpg";
import p2_31 from "./p2-31.jpg";
import p2_32 from "./p2-32.jpg";
import p2_33 from "./p2-33.jpg";
import p2_34 from "./p2-34.jpg";
import p2_35 from "./p2-35.jpg";
import p2_36 from "./p2-36.jpg";
import p2_37 from "./p2-37.jpg";
import p2_38 from "./p2-38.jpg";
import p2_39 from "./p2-39.jpg";
import p2_40 from "./p2-40.jpg";
import p2Fp1np3d from "./p2-fp-1np-3d.jpg";
import p2Fp1np2d from "./p2-fp-1np-2d.jpg";
import p2Fp2np3d from "./p2-fp-2np-3d.jpg";
import p2Fp2np2d from "./p2-fp-2np-2d.jpg";
import p2FpSklep3d from "./p2-fp-sklep-3d.jpg";
import p2FpSklep2d from "./p2-fp-sklep-2d.jpg";

export const pozden2Images = [
  p2_1, p2_2, p2_3, p2_4, p2_5, p2_6, p2_7, p2_8, p2_9, p2_10,
  p2_11, p2_12, p2_13, p2_14, p2_15, p2_16, p2_17, p2_18, p2_19, p2_20,
  p2_21, p2_22, p2_23, p2_24, p2_25, p2_26, p2_27, p2_28, p2_29, p2_30,
  p2_31, p2_32, p2_33, p2_34, p2_35, p2_36, p2_37, p2_38, p2_39, p2_40,
];

export const pozden2FloorPlans = [
  { image: p2Fp1np3d, label: "1. NP – 3D" },
  { image: p2Fp1np2d, label: "1. NP – 2D" },
  { image: p2Fp2np3d, label: "2. NP – 3D" },
  { image: p2Fp2np2d, label: "2. NP – 2D" },
  { image: p2FpSklep3d, label: "Sklep – 3D" },
  { image: p2FpSklep2d, label: "Sklep – 2D" },
];
